import { CloudProvidersFilter } from '../_components/CloudProvidersFilter';

import { EdgeLocationStateFilter } from '../_components/EdgeLocationStateFilter';
import { ClearAllButton, Search } from '@cast/shared-search-ui';

import { Stack } from '@cast/design-system';

type EdgeLocationsFiltersProps = {
  showStateFilter?: boolean;
};

export const EdgeLocationsFilters = ({
  showStateFilter = true,
}: EdgeLocationsFiltersProps) => {
  return (
    <Stack direction="row" gap={8} data-testid="edge-locations-filters">
      <Search
        disableRecentSearch
        placeholder={!showStateFilter ? 'Search edge locations' : undefined}
      />
      {showStateFilter && <EdgeLocationStateFilter />}
      <CloudProvidersFilter />
      <ClearAllButton />
    </Stack>
  );
};
